import { store as auth } from '@/views/auth'
import { store as fila } from '@/views/FilaProcessamento'
import { store as remessas } from '@/views/AcompanhamentoRemessa'
export default {
  auth,
  fila,
  remessas
}